export enum EResolution {
    '2400X2400' = 0,
    '2438X2438' = 1
}